import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import Avatar from '@mui/material/Avatar';
import ImageIcon from '@mui/icons-material/Image';
import WorkIcon from '@mui/icons-material/Work';
import BeachAccessIcon from '@mui/icons-material/BeachAccess';

/* __next_internal_client_entry_do_not_use__ default auto */ import { createDemoClient } from '@mui/internal-core-docs/utils/createDemoClient';
const ClientProvider = createDemoClient(import.meta.url, { precompute: { externals: { "@mui/material/List": List, "@mui/material/ListItem": ListItem, "@mui/material/ListItemText": ListItemText, "@mui/material/ListItemAvatar": ListItemAvatar, "@mui/material/Avatar": Avatar, "@mui/icons-material/Image": ImageIcon, "@mui/icons-material/Work": WorkIcon, "@mui/icons-material/BeachAccess": BeachAccessIcon } } });
export default ClientProvider;
